import { render, staticRenderFns } from "./FollowUpCro.vue?vue&type=template&id=5110d2ab&scoped=true"
import script from "./FollowUpCro.vue?vue&type=script&lang=js"
export * from "./FollowUpCro.vue?vue&type=script&lang=js"
import style0 from "./FollowUpCro.vue?vue&type=style&index=0&id=5110d2ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5110d2ab",
  null
  
)

export default component.exports